import { ApiMetaDataDTO, ErrorDTO } from 'declarations'
import { useMutation } from '@tanstack/react-query'
import { client } from 'services/helpers/apiConfig'
import { toast } from 'react-toastify'

export type ThreadDraftSendParamsDTO = {
  uuid: string
}

export const useThreadDraftSendMutation = () =>
  useMutation<any, ErrorDTO, ThreadDraftSendParamsDTO>({
    mutationFn: async (params) => {
      try {
        const res = await client.put(`/thread/draft/send/${params.uuid}`)

        return res.data.data
      } catch (err) {
        toast.error(err.response.data.message)
        throw err.response.data
      }
    },
  })
